export const getAdvancedGrid = (grid: boolean[][]): Array<Array<boolean>> =>
  grid.map((row, rowId) =>
    row.map((cell, colId) => {
      const neighborCount = getCellNeighborCount(grid, rowId, colId);

      if (cell && (neighborCount < 2 || neighborCount > 3)) return false;
      else if (!cell && neighborCount === 3) return true;
      return cell;
    }),
  );

const getCellNeighborCount = (
  grid: boolean[][],
  cellRowId: number,
  cellColId: number,
): number => {
  const gridDimensions = { row: grid.length, column: grid[0].length };
  const neighborIndexes = [-1, 0, 1];

  return neighborIndexes.reduce((rowNeighbors, rowIter) => {
    return (
      rowNeighbors +
      neighborIndexes.reduce((colNeighbors, colIter) => {
        if (rowIter === 0 && colIter === 0) return colNeighbors;

        const row =
          (cellRowId + rowIter + gridDimensions.row) % gridDimensions.row;
        const col =
          (cellColId + colIter + gridDimensions.column) % gridDimensions.column;

        return grid[row][col] ? colNeighbors + 1 : colNeighbors;
      }, 0)
    );
  }, 0);
};
